/* global document */

import classNames from 'classnames';
import { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

import { removeAPIError } from 'redux/apiErrors/actions';
import { registerModalOpen, registerModalClose } from 'redux/modals/actions';

import APIError from './components/APIError';

class Modal extends Component {
  componentDidMount() {
    const { props } = this;
    // const body = document.getElementsByTagName('body')[0];
    // body.classList.add('modal-open');
    props.registerModalOpen();
  }

  componentWillUnmount() {
    const { props } = this;
    // const body = document.getElementsByTagName('body')[0];
    // body.classList.remove('modal-open');
    props.removeAPIError();
    // this.props.removeFormError();
    props.registerModalClose();
  }

  handleClickClose = (e) => {
    const { props } = this;
    e.preventDefault();
    props.onCloseModal();
  };

  render() {
    const { title, children, className } = this.props;
    return ReactDOM.createPortal(
      <div className="c7-modal c7-visible">
        <div className={classNames('c7-modal__content', className)}>
          <a onClick={this.handleClickClose} className="c7-modal__close">
            X
          </a>
          <APIError position="modal" />
          <h2>{title}</h2>

          {children}
        </div>
      </div>,
      document.getElementById('c7-modal')
    );
  }
}

export default connect(null, {
  registerModalOpen,
  registerModalClose,
  removeAPIError
})(Modal);
